import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles';
import Text from '../../OC/oc-text';
import { connectLocation } from '../../location/LocationConnectors';

const RatingFilterBase = ({ ratingsSelected = [], setRatingsSelected, t }) => {
  const options = [
    { value: '5', text: t('bazaarvoice.star_rating', { count: 5 }) },
    { value: '4', text: t('bazaarvoice.star_rating', { count: 4 }) },
    { value: '3', text: t('bazaarvoice.star_rating', { count: 3 }) },
    { value: '2', text: t('bazaarvoice.star_rating', { count: 2 }) },
    { value: '1', text: t('bazaarvoice.star_rating', { count: 1 }) },
  ];

  return (
    <div css={styles}>
      <p className="rating-filter__label">
        <Text content={t('bazaarvoice.filter_by_star_rating')} />
      </p>
      <ul className="rating-filter__list">
        {options.map(option => {
          const isSelected = ratingsSelected.includes(option.value);
          return (
            <li
              key={option.value}
              className={classNames('rating-filter__list-item', {
                'rating-filter__list-item--selected': isSelected,
              })}
            >
              <input
                type="checkbox"
                className="rating-filter__list-item-checkbox"
                id={`rating-${option.value}`}
                value={option.value}
                checked={isSelected}
                onChange={() => setRatingsSelected(option.value)}
                data-testid={`rating-${option.value}`}
                data-track={isSelected ? 'remove-filter' : 'filter'}
                data-track-filter-name="star rating"
                data-track-filter-option={option.text}
              />
              <label htmlFor={`rating-${option.value}`} className="rating-filter__list-item-label">
                <span>{option.text}</span>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

RatingFilterBase.propTypes = {
  ratingsSelected: PropTypes.arrayOf(PropTypes.string).isRequired,
  setRatingsSelected: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export const RatingFilter = connectLocation(RatingFilterBase);
